module.exports = __webpack_public_path__ + "img/TWN.0398f880.svg";